import {
    TAGS_OPEN_CLOSE_DELETE_TAGS_MODAL,
    TAGS_DELETE_TAGS,
    TAGS_DELETE_TAGS_RESPONSE
} from "Redux/actionTypes";

export const tagsOpenCloseDeleteTagsModal = (open, selected) => {
    return {
        type: TAGS_OPEN_CLOSE_DELETE_TAGS_MODAL,
        payload: { open, selected },
    };
};

export const tagsDeleteTags = (data) => {
    return {
        type: TAGS_DELETE_TAGS,
        payload: { data },
    };
};

export const tagsDeleteTagsResponse = (response) => {
    return {
        type: TAGS_DELETE_TAGS_RESPONSE,
        payload: { response } ,
    };
};